import useReveal from "../hooks/useReveal";
import { Star, Quote } from "lucide-react";
import { testimonials } from "../mock/mock";

export default function Testimonials() {
  const [ref, inView] = useReveal();

  return (
    <section id="reviews" className="py-24 md:py-32 bg-[#F2ECE2]">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div ref={ref} className={`text-center max-w-2xl mx-auto mb-16 reveal ${inView ? "in-view" : ""}`}>
          <p className="text-[#A17E4A] tracking-[0.25em] uppercase text-xs mb-4">Testimonials</p>
          <h2 className="font-serif text-3xl md:text-5xl text-[#2A2521] mb-5">
            What Our Customers Say
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-7">
          {testimonials.map((t, i) => (
            <div
              key={t.name}
              className={`relative bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-shadow duration-400 reveal ${
                inView ? "in-view" : ""
              }`}
              style={{ animationDelay: `${i * 120}ms` }}
            >
              <Quote className="w-10 h-10 text-[#A17E4A]/25 mb-4" />
              <div className="flex gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, k) => (
                  <Star key={k} className="w-4 h-4 fill-[#E0B04A] text-[#E0B04A]" />
                ))}
              </div>
              <p className="text-[#4A423A] leading-relaxed mb-6 italic">“{t.text}”</p>
              <div className="flex items-center gap-3 pt-4 border-t border-[#EFE9DF]">
                <div className="w-11 h-11 rounded-full bg-[#A17E4A] text-white flex items-center justify-center font-serif text-lg">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <p className="font-medium text-[#2A2521]">{t.name}</p>
                  <p className="text-sm text-[#8A8177]">{t.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
